export default "__VITE_ASSET__BlTwJeN7__"